export default "__VITE_ASSET__BxNBJ2EP__"